import {
  BusinessUnitLookupV2,
  CompanyLookupV2,
  PayrollServiceProviderLookupV2,
  PayrollServiceProviderUserLookupV2,
} from '@xemplo/gp-types';

export type LookupRow = {
  id: string;
  value: string;
};

export const LookupType = {
  companies: 'companies',
  payrollServiceProviders: 'payrollServiceProviders',
  payrollServiceProviderUsers: 'payrollServiceProviderUsers',
  businessUnits: 'businessUnits',
} as const;

export type LookupType = (typeof LookupType)[keyof typeof LookupType];

export type LookupTypeMap = {
  companies: CompanyLookupV2;
  payrollServiceProviders: PayrollServiceProviderLookupV2;
  payrollServiceProviderUsers: PayrollServiceProviderUserLookupV2;
  businessUnits: BusinessUnitLookupV2;
};
